// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5160":"86345e26","6871":"86345e26"}[chunkId] + ".chunk.css";
};